import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import React__default, { useState } from 'react';
import { api } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { prependPrefix } from '../../../../../utils/style.js';
import { useHeaderContext } from '../../../context.js';
import { FEED_PAGE_URL, HISTORY_PAGE_URL } from '../../../url.js';
import { Feed } from './feed.js';
import { History } from './history.js';
import { Link } from './link.js';
import { StartBtn } from './start-btn.js';
import { SubscribedDrama } from './subscribed-drama.js';
import { UserBox } from './user-box.js';

var CURRENT_PAGE_URL = window.location.origin + window.location.pathname;

var DropdownContainer = function DropdownContainer(_ref) {
  var _ref$activated = _ref.activated,
      activated = _ref$activated === void 0 ? false : _ref$activated,
      className = _ref.className,
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      linkContent = _ref.linkContent;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDropdown = _useState2[0],
      setShowDropdown = _useState2[1];

  var handleMouseEnterDropdown = function handleMouseEnterDropdown() {
    setShowDropdown(true);
  };

  var handleMouseLeaveDropdown = function handleMouseLeaveDropdown() {
    setShowDropdown(false);
  };

  if (disabled) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames(className, prependPrefix('menu'), {
        activated: activated
      })
    }, linkContent);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, prependPrefix('menu'), {
      activated: activated
    }),
    onMouseEnter: handleMouseEnterDropdown,
    onMouseLeave: handleMouseLeaveDropdown
  }, linkContent, showDropdown && children);
};

var PCView = function PCView() {
  var _useHeaderContext = useHeaderContext(),
      loading = _useHeaderContext.loading,
      user = _useHeaderContext.user,
      startBtnConfig = _useHeaderContext.startBtnConfig;

  var renderUserDropdown = function renderUserDropdown() {
    var _context;

    if (!user) {
      return null;
    }

    var HOMEPAGE_URL = _concatInstanceProperty(_context = "".concat(api.MISSEVAN_SITE_MAIN, "/")).call(_context, user.id);

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DropdownContainer, {
      className: prependPrefix('subscribed-drama'),
      linkContent: /*#__PURE__*/React__default.createElement(Link, {
        content: "\u6211\u7684\u8FFD\u5267",
        href: "".concat(HOMEPAGE_URL, "/#/subscription")
      }),
      activated: _includesInstanceProperty(CURRENT_PAGE_URL).call(CURRENT_PAGE_URL, "".concat(HOMEPAGE_URL, "/#/subscription"))
    }, /*#__PURE__*/React__default.createElement(SubscribedDrama, {
      userId: user.id
    })), /*#__PURE__*/React__default.createElement(DropdownContainer, {
      className: prependPrefix('feed'),
      linkContent: /*#__PURE__*/React__default.createElement(Link, {
        content: "\u52A8\u6001",
        href: FEED_PAGE_URL
      }),
      activated: CURRENT_PAGE_URL === FEED_PAGE_URL
    }, /*#__PURE__*/React__default.createElement(Feed, null)), /*#__PURE__*/React__default.createElement(DropdownContainer, {
      className: prependPrefix('history'),
      linkContent: /*#__PURE__*/React__default.createElement(Link, {
        content: "\u5386\u53F2",
        href: HISTORY_PAGE_URL
      }),
      activated: CURRENT_PAGE_URL === HISTORY_PAGE_URL
    }, /*#__PURE__*/React__default.createElement(History, null)));
  };

  if (loading) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: prependPrefix('pc-view')
  }, /*#__PURE__*/React__default.createElement(UserBox, null), renderUserDropdown(), !!startBtnConfig && /*#__PURE__*/React__default.createElement(DropdownContainer, {
    disabled: !startBtnConfig.config,
    className: prependPrefix('start-btn'),
    linkContent: startBtnConfig.renderTitle
  }, /*#__PURE__*/React__default.createElement(StartBtn, null)));
};

export { PCView };
